import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { CurrentPlan } from '../../../core/models/corporate/current-plan.model';
import { PlanCurrent } from '../../../core/models/corporate/plan-current.model';
import { TransactionStatus } from '../../../shared/constants/transaction-status';
import { trialRemainingLabel } from '../../../shared/utils/trial-remaining.util';

@Component({
  selector: 'app-plan-view',
  standalone: false,
  templateUrl: './plan-view.component.html',
  styleUrl: './plan-view.component.scss'
})
export class PlanViewComponent {
  TRANSACTION_STATUS = TransactionStatus;

  @Input() plan: CurrentPlan | null = null;
  @Input() currentPlan: PlanCurrent | null = null;
  @Output() menuClick = new EventEmitter<void>();

  @Input() onlyCurrentPlan = false;

  constructor(private transloco: TranslocoService) {}

  navigate() {
    this.menuClick.emit();
  }

  get vehiclesProgress(): number {
    const current = this.plan?.limits?.vehicles?.current ?? 0;
    const max = this.plan?.limits?.vehicles?.maximum ?? 1;
    return Math.min(100, Math.round((current / max) * 100));
  }

  get isTrial(): boolean {
    return this.plan?.isTrial || this.currentPlan?.isTrial || false;
  }

  get trialTimeRemaining() {
    return this.plan?.trialTimeRemaining || this.currentPlan?.trialTimeRemaining;
  }

  get isTrialExpiringSoon(): boolean {
    return this.trialTimeRemaining?.isExpiringSoon || false;
  }

  get trialDaysRemaining(): number {
    return this.trialTimeRemaining?.days || 0;
  }

  get requiresPaymentMethod(): boolean {
    return this.plan?.requiresPaymentMethod || this.currentPlan?.requiresPaymentMethod || false;
  }

  getTrialStatusText(): string {
    if (!this.isTrial) return '';
    return trialRemainingLabel(this.transloco, this.trialDaysRemaining, this.trialTimeRemaining?.hours || 0);
  }
}